import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { FirebaseAuthContext } from 'libs.firebase_react';
import { JobsContext } from 'libs.jobs.react';
import { useLocalizeMessage, useToastNotification } from 'libs.nucleus';
import { ApiClientService, useApiClient } from 'libs.react_internal';
export const useImportFromAsset = () => {
    const { post } = useApiClient(ApiClientService.WEB);
    const { addNotification } = useToastNotification();
    const translate = useLocalizeMessage();
    const { firebaseToken } = useContext(FirebaseAuthContext);
    const jobsContext = useContext(JobsContext);
    const handleJobSuccess = () => {
        addNotification({
            title: translate('Translation copy succeeded'),
            type: 'success',
        });
    };
    const handleJobError = () => {
        addNotification({
            title: translate('Translation copy failed'),
            subtitle: translate('There was a network error when trying to copy the translations. Please try it again.'),
            type: 'error',
        });
    };
    return useMutation({
        mutationKey: ['translation', 'import_from_asset'],
        mutationFn: async (body) => {
            const response = await post(`/api/v2/translation/import_from_asset`, body, {
                headers: {
                    Authorization: `Bearer ${firebaseToken}`,
                },
                withCredentials: false,
            });
            return response.data;
        },
        onSuccess: (data) => {
            const jobIds = Array.isArray(data?.jobIds) ? data.jobIds : [];
            if (jobIds.length > 0 && jobsContext) {
                jobIds.forEach((jobId) => {
                    jobsContext.addJobHandler(jobId, {
                        onDone: handleJobSuccess,
                        onError: handleJobError,
                    });
                });
            }
        },
        onError: () => {
            addNotification({
                title: translate('Translation copy failed'),
                subtitle: translate('There was a network error when trying to copy the translations. Please try it again.'),
                type: 'error',
            });
        },
        retry: false,
    });
};
